module.exports = __webpack_public_path__ + "ba.b2a453d5eff3dad3d58d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ba.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ba.svg
// module chunks = styles